import { Link } from 'react-router-dom'

function BohemiaIntercambioNav() {
  return (
    <Link to='/groups/SecretSanta' className="w-full" onClick={() => { gtag('event', 'event_to_ga', { event_category: 'navegacion_memorama', event_label: 'Home links' }) }}>
      <img src={`${AZURE_BASE_URL}/home-banner-intercambio.webp`} alt='bohemia' className='w-full' />
    </Link>
  )
}

export default BohemiaIntercambioNav